import clsx from 'clsx';
import { Drawer } from '@linktivity/link-ui';

import type { StationOption } from '../../types';

import styles from './stationPicker.module.css';

export interface StationPickerProps<T extends StationOption = StationOption> {
  visible: boolean;
  title: string;
  closeLabel: string;
  stations: readonly T[];
  selectedCode?: string;
  excludeCode?: string;
  onSelect: (station: T) => void;
  onClose: () => void;
}

const StationPicker = <T extends StationOption>({
  visible,
  title,
  closeLabel,
  stations,
  selectedCode,
  excludeCode,
  onSelect,
  onClose
}: StationPickerProps<T>) => (
  <Drawer visible={visible} position="bottom" onClose={onClose}>
    <div className={styles.sheet}>
      <div className={styles.header}>
        <button
          type="button"
          className={styles.close}
          aria-label={closeLabel}
          onClick={onClose}
        >
          ✕
        </button>
        <span className={styles.title}>{title}</span>
      </div>

      <ul className={styles.stationList}>
        {stations.map(station => {
          const disabled = station.code === excludeCode;
          const selected = station.code === selectedCode;
          return (
            <li key={station.code}>
              <button
                type="button"
                className={clsx(
                  styles.stationItem,
                  selected && styles.stationItemSelected,
                  disabled && styles.stationItemDisabled
                )}
                aria-pressed={selected}
                disabled={disabled}
                onClick={() => onSelect(station)}
              >
                <span>{station.name}</span>
                {selected && (
                  <span className={styles.check} aria-hidden="true">
                    ✓
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  </Drawer>
);

export default StationPicker;
